import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'emp-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, CommonModule, TranslatePipe, NgOptimizedImage],
  host: {
    '(window:resize)': 'updateViewport()'
  }
})
export class HomePageComponent {
  private static readonly desktopBreakpoint = 1365;

  private readonly viewportWidth = signal(this.getViewportWidth());

  protected readonly isCompactLayout = computed(() => this.viewportWidth() <= HomePageComponent.desktopBreakpoint);
  protected readonly isDesktopLayout = computed(() => this.viewportWidth() > HomePageComponent.desktopBreakpoint);

  protected updateViewport(): void {
    this.viewportWidth.set(this.getViewportWidth());
  }

  private getViewportWidth(): number {
    return typeof window === 'undefined' ? HomePageComponent.desktopBreakpoint : window.innerWidth;
  }
}
